// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* stylelint-disable max-line-length */
:-moz-placeholder,
:-ms-input-placeholder,
::-ms-input-placeholder,
::-webkit-input-placeholder,
::placeholder {
  color: #C4C4C4;
}

:focus {
  outline: none;
}

html,
body {
  height: 100%;
}

body {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  color: #262626;
  background: #F1F2F5;
  font: 3.733333vw/5.333333vw "PingFang SC", "Helvetica Neue", Helvetica, "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

input,
textarea {
  -webkit-appearance: none;
          appearance: none;
  outline: none;
  cursor: pointer;
}

body,
div,
span,
header,
footer,
nav,
section,
aside,
article,
ul,
dl,
dt,
dd,
li,
a,
p,
h1,
h2,
h3,
h4,
h5,
h6,
i,
b,
textarea,
button,
input,
select,
figure,
figcaption {
  margin: 0;
  border: none;
  padding: 0;
  font-family: "PingFang SC", "Helvetica Neue", Helvetica, "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  text-decoration: none;
  list-style: none;
  font-style: normal;
  box-sizing: border-box;
  word-break: break-all;
  -webkit-tap-highlight-color: transparent;
  -webkit-font-smoothing: antialiased;
}
body:hover, body:focus,
div:hover,
div:focus,
span:hover,
span:focus,
header:hover,
header:focus,
footer:hover,
footer:focus,
nav:hover,
nav:focus,
section:hover,
section:focus,
aside:hover,
aside:focus,
article:hover,
article:focus,
ul:hover,
ul:focus,
dl:hover,
dl:focus,
dt:hover,
dt:focus,
dd:hover,
dd:focus,
li:hover,
li:focus,
a:hover,
a:focus,
p:hover,
p:focus,
h1:hover,
h1:focus,
h2:hover,
h2:focus,
h3:hover,
h3:focus,
h4:hover,
h4:focus,
h5:hover,
h5:focus,
h6:hover,
h6:focus,
i:hover,
i:focus,
b:hover,
b:focus,
textarea:hover,
textarea:focus,
button:hover,
button:focus,
input:hover,
input:focus,
select:hover,
select:focus,
figure:hover,
figure:focus,
figcaption:hover,
figcaption:focus {
  outline: none;
}

img {
  border-style: none;
  font-size: 0;
}

input:-webkit-autofill,
textarea:-webkit-autofill,
select:-webkit-autofill {
  box-shadow: 0 0 0 266.666667vw #FFFFFF inset;
  box-shadow: 0 0 0 1000px #FFFFFF inset;
}

input[type=button] {
  display: block;
}

input::-webkit-inner-spin-button {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/styles/reset.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,sCAAA;AAEA;;;;;EAIgB,cAAA;AAEhB;;AACA;EACE,aAAA;AAEF;;AACA;;EAEE,YAAA;AAEF;;AACA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;EACA,wIAAA;AAEF;;AAEA;;EAEE,wBAAA;UAAA,gBAAA;EACA,aAAA;EACA,eAAA;AACF;;AAGA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA8BE,SAAA;EACA,YAAA;EACA,UAAA;EACA,yHAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,qBAAA;EACA,wCAAA;EACA,mCAAA;AAAF;AAEE;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EACU,aAAA;AA0DZ;;AAtDA;EACE,kBAAA;EACA,YAAA;AAyDF;;AArDA;;;EAGE,4CAAA;EACA,sCAAA;AAwDF;;AApDA;EACE,cAAA;AAuDF;;AApDA;EACE,aAAA;AAuDF","sourcesContent":["/* stylelint-disable max-line-length */\n\n:-moz-placeholder,\n:-ms-input-placeholder,\n::-ms-input-placeholder,\n::-webkit-input-placeholder,\n::placeholder { color: #C4C4C4; }\n\n// 去除焦点外边框\n:focus {\n  outline: none;\n}\n\nhtml,\nbody {\n  height: 100%;\n}\n\nbody {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  color: #262626;\n  background: #F1F2F5;\n  font: 14px/20px  \"PingFang SC\", \"Helvetica Neue\", Helvetica, \"Hiragino Sans GB\", \"Microsoft YaHei\", \"微软雅黑\", Arial, sans-serif;\n}\n\n// 去除input标签的默认样式\ninput,\ntextarea {\n  appearance: none;\n  outline: none;\n  cursor: pointer;\n}\n\n// 重置各标签的默认样式\nbody,\ndiv,\nspan,\nheader,\nfooter,\nnav,\nsection,\naside,\narticle,\nul,\ndl,\ndt,\ndd,\nli,\na,\np,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\ni,\nb,\ntextarea,\nbutton,\ninput,\nselect,\nfigure,\nfigcaption {\n  margin: 0;\n  border: none;\n  padding: 0;\n  font-family: \"PingFang SC\", \"Helvetica Neue\", Helvetica, \"Hiragino Sans GB\", \"Microsoft YaHei\", \"微软雅黑\", Arial, sans-serif;\n  text-decoration: none;\n  list-style: none;\n  font-style: normal;\n  box-sizing: border-box;\n  word-break: break-all;\n  -webkit-tap-highlight-color: transparent;\n  -webkit-font-smoothing: antialiased;\n\n  &:hover,\n  &:focus { outline: none; }\n}\n\n// 清除IE下图片的边框\nimg {\n  border-style: none;\n  font-size: 0;\n}\n\n// 解决chrome浏览器默认黄色背景问题\ninput:-webkit-autofill,\ntextarea:-webkit-autofill,\nselect:-webkit-autofill {\n  box-shadow: 0 0 0 1000px #FFFFFF inset;\n  box-shadow: 0 0 0 1000px #FFFFFF inset;\n}\n\n// 重置点击按钮类型的input\ninput[type=\"button\"] {\n  display: block;\n}\n\ninput::-webkit-inner-spin-button {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
